import React, { Fragment } from 'react'

const ScaningTeam = () => {
  return <Fragment>ScaningTeam</Fragment>
}

export default ScaningTeam
